import * as Website from '../../Config/Website.js';
import * as MvAnimejs from './Modules/MvAnimejs.js';


const preinit = () => {

}

const init = () => {
  MvAnimejs.init();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {
  MvAnimejs.load();
}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}